import { render } from "./AlertPanel.vue?vue&type=template&id=5b43d810&scoped=true&lang=pug"
import script from "./AlertPanel.vue?vue&type=script&lang=js"
export * from "./AlertPanel.vue?vue&type=script&lang=js"

import "./AlertPanel.vue?vue&type=style&index=0&id=5b43d810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b43d810"]])

export default __exports__